import { DefinitionsCampaign as Campaign } from '@integrations/schemas/types/gate/integrations/webhook/v2';

export enum ParentCategoryName {
  newsletter_marketing = 'newsletter_marketing',
  partners = 'partners',
  legal_rules = 'legal_rules',
  other = 'other',
}

export interface PersonalityTestGroup {
  group: string;
  groupName: string;
}

export interface OptinCategory {
  name: string;
  technicalName?: string; // Can be put to required after releasing loyalty integrator !26
  parentName?: ParentCategoryName;
}

export interface Optins {
  id: number;
  value: string;
  variable: string;
  label: string;
  categories?: OptinCategory[];
}

interface Score {
  kind: string;
  value: number;
}

export interface GlobalVariable {
  key: string;
  value: string;
}

export interface QualifioEngageCampaignEventPayload {
  amountVatExcluded?: number;
  amountVatIncluded?: number;
  shippingCostVatIncluded?: number;
  totalAmountVatIncluded?: number;
  Basket?: number;
  basketTotal?: number;
  quantityTotal?: number;
  participationId: string;
  timestamp: string;
  campaignId: string;
  campaignType: Campaign['type'];
  campaignChannelUuid: string;
  campaignThemes: { code: string; description: string }[];
  campaignName: string;
  campaign: {
    id: number;
    themes: { code: string; description: string }[];
    channelUuid: string;
    campaignType: Campaign['type'];
    name: string;
  };
  score: Score[];
  optins: Optins[];
  globalVariables: GlobalVariable[];
  personalityTest?: PersonalityTestGroup[];
  website: {
    id: number;
    name: string;
  };
  websiteName: string;
  variables: { key: string; value: string | { [k: string]: string } }[];
  gift?: {
    won: boolean;
    wonAt?: string;
    giftData?: {
      id?: number;
      codesListId?: number;
      plannedAt: string;
      label: string;
      description?: string;
      picture?: string;
      url?: string;
    };
  };
  rewards?: {
    codeList: string;
    code: string;
    giftId?: number;
  }[];
  uniqueCode?: string;
  burnedCodes?: {
    variable: string;
    code: string;
  }[];
}
